import _get from "lodash/get";
import React from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";
import LogIn from "./containers/LogIn";
import Privacy from "./containers/Privacy";
import AppSecure from "./AppSecure";

function App(props) {

  return (
    <div>
      {props.preCheck ? (
        <Router>
          <div>
            <Route exact path="/" component={LogIn} />
            <Route path="/dashboard" component={AppSecure} />
            <Route path="/privacy" component={Privacy} />
          </div>
        </Router>
      ) : (
        <Router>
          <div>
            <Route exact path="/" component={LogIn} />
          </div>
        </Router>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  preCheck: state.appData.preCheck,
  isUnity: _get(state, "appData.isUnity", false),
});

export default connect(mapStateToProps, {})(App);
